var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8464",
    transform: "translate(3 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8598"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_364",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-3 4)",
    fill: "#2b8ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    d: "M6.514,18.6.281,12.365a.959.959,0,0,1,0-1.356L1.637,9.653a.959.959,0,0,1,1.356,0l4.2,4.2,8.994-8.993a.959.959,0,0,1,1.356,0L18.9,6.214a.959.959,0,0,1,0,1.356L7.87,18.6A.959.959,0,0,1,6.514,18.6Z",
    transform: "translate(3.411 9.737)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active_icon.b17214d64a2349c60da1469dc358b319.svg";
export { ForwardRef as ReactComponent };